import { UREEKA_BASEURL, ZENREG_MKTG_REDIRECT_URL } from '#client/utils/constants';

/**
 * Generate Ureeka URL for Navigation based on entitlement
 *
 * @param {{
 *  businessEntityUuid: string
 *  email: string
 *  registrationCode?: string
 * }} params
 * @returns {string} redirect destination
 */
export function getUreekaUrlRedirect({
  businessEntityUuid,
  email,
  registrationCode
}) {
  // Handle registration redirect
  if (registrationCode) {
    const searchUreekaParams = new URLSearchParams({
      regcode: registrationCode,
      ea: email
    });
    return `${UREEKA_BASEURL}sign-up/?${searchUreekaParams}`;
  }

  // Handle purchase redirect
  const searchZenRegParams = new URLSearchParams({
    companyId: businessEntityUuid
  });

  return `${ZENREG_MKTG_REDIRECT_URL}?${searchZenRegParams}`;
}
